import service from './service';
import { UrlBuilder } from './url-builder';

export const managerDashboardInfo = async (companyId, premiseId) => {
  const builder = new UrlBuilder(`/manager/company/${companyId}/premise/${premiseId}/statistics`);
  try {
    const response = await service.get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
